import { styled } from "@mui/material";
import SelectField from "controls/global/select-field";
import React from "react";
import { padding } from "theme/defaultStyle";
import { useLookup } from "utils/context/LookupContext";

type Props = {
  isNewFile: boolean;
  noIssuedProducts: boolean;
  isOverride: boolean;
  overrideReasonError: boolean;
  isLocked: boolean;
  onChange: (event: React.ChangeEvent<any>) => void;
};

const StyledSelectField = styled(SelectField)({
  width: "287px",
  "& .MuiSelect-select": {
    padding: `${padding.medium1_5} ${padding.medium2}`,
  },
});

export default function OverrideReasonField({
  isNewFile,
  noIssuedProducts,
  isOverride,
  overrideReasonError,
  isLocked,
  onChange,
}: Props) {
  const [{ overrideReasonTypes }] = useLookup();

  return (
    <StyledSelectField
      disabled={noIssuedProducts || isNewFile || Boolean(!isOverride) || isLocked}
      label="Override Reason"
      name="pricing.overrideReason"
      options={overrideReasonTypes}
      delaySearching={500}
      allowsDelete={false}
      showTooltipAlways
      onChange={onChange}
      highlightError={overrideReasonError}
    />
  );
}
